import { BreadcrumbInterface } from '@/Support/Menus/Interfaces/Breadcrumb'
import { defineStore } from 'pinia'
import { usePage } from '@inertiajs/vue3'
import AIResponseModal from '@/Pages/App/AI/AIResponseModal.vue'
import * as Fathom from 'fathom-client'

type AiModal = 'response' | 'query'

interface State {
  breadcrumbs: BreadcrumbInterface[]
  showCommandPalette: boolean
  axiosLoader: number
  darkMode: boolean
  currentScreenMode: string
  aiResponseModal: InstanceType<typeof AIResponseModal> | null
  snowFall: boolean
}

export const useAppLayout = defineStore('appLayout', {
  state: (): State => {
    return {
      breadcrumbs: [],
      showCommandPalette: false,
      axiosLoader: 0,
      darkMode: document.documentElement.classList.contains('dark'),
      currentScreenMode: localStorage.theme || 'system',
      aiResponseModal: null,
      snowFall: true,
    }
  },
  getters: {
    isDarkMode: state => state.darkMode,
    currentLanguage: () => usePage().props.language as string,
    currentLocale: () => usePage().props.locale as string,
  },
  actions: {
    openCommandPalette(status = true) {
      this.showCommandPalette = status
    },
    closeCommandPalette() {
      this.openCommandPalette(false)
    },
    setDarkMode() {
      this.darkMode = document.documentElement.classList.contains('dark')
    },
    setCurrentScreenMode(mode: string) {
      this.currentScreenMode = mode
    },
    openAiQuery() {
      this.aiResponseModal?.open()
    },
    cleanAiQuery() {
      this.aiResponseModal?.cleanConversation()
    },
    toggleSnowFall() {
      this.snowFall = !this.snowFall
    },
    trackingEvent(name: string, options?: TrackingEventOptions) {
      Fathom.trackEvent(name, options)
    },
  },
})
